import React from 'react';
import language from "../../languages/language";
import TitleAndInfo from "../TitleAndInfo/TitleAndInfo";
import {Col, Row, Upload} from "antd";
import CameraOutlined from "@ant-design/icons/lib/icons/CameraOutlined";
import UploadOutlined from "@ant-design/icons/lib/icons/UploadOutlined";
import {connect} from "react-redux";
import PublicLayout from "../Public";
import {addFileName, getBase64File} from "../../Helpers/utils";
import addDocument from "../../actions/addDocument";
import showPhoto from "../../actions/showPhoto";
import uploadID from "../../actions/uploadID";

class Document extends React.Component
{
    state={hasCam:false}
    componentDidMount()
    {
        navigator.mediaDevices.enumerateDevices().then(this.enableCam);
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if(this.props.documents.length===this.props.uploadFilesInfo.length)
            this.props.uploadID(this.props.formValues);
    }

    enableCam=(mediaDevices)=>
    {
        const devices=mediaDevices.filter(({ kind }) => kind === "videoinput");
        this.setState({hasCam:devices && devices.length && devices.length>0});
    };

    onFile=(file)=>
    {
        getBase64File(file).then(newFile=>this.props.addDocument({front:{base64:newFile,name:file.name}}));
    };

    render()
    {
        return <PublicLayout title={'logo'} size={'large'}>
            <TitleAndInfo info={addFileName(this.props,language[this.props.language].signUpText3)}/>
            <Row type={'flex'}>
                {this.state.hasCam?<Col onClick={this.props.showPhoto} style={{display:'flex',flex:1,backgroundColor:'#f8f8f8',height:'130px',
                    alignItems:'center',justifyContent:'center',margin:'5px 20px 10px 20px',cursor: 'pointer',textAlign:'center'}}>
                    <div style={{fontSize:'60px'}}>
                        <CameraOutlined/>
                    </div>
                    <div style={{fontSize:'30px',marginLeft:'10px'}}>
                        {language[this.props.language].takePictureLabel}
                    </div>
                </Col>:''}
                <Col style={{display:'flex',flex:1,backgroundColor:'#f8f8f8',height:'130px',
                    alignItems:'center',justifyContent:'center',margin:'5px 20px 10px 20px',cursor: 'pointer',textAlign:'center'}}>
                <span style={{width:'100%'}}>
                <Upload fileList={[]} beforeUpload={(file)=>{this.onFile(file);return false;}}>
                    <Col style={{display:'flex',flex:1,backgroundColor:'#f8f8f8',height:'130px',
                        alignItems:'center',justifyContent:'center',cursor: 'pointer'}}>

                        <div style={{fontSize:'60px'}}>
                            <UploadOutlined/>
                        </div>
                        <div style={{fontSize:'30px',marginLeft:'10px'}}>
                            {language[this.props.language].uploadLabel}
                        </div>
                    </Col>
                </Upload>
                    </span>
                </Col>
            </Row>
        </PublicLayout>;
    }
}
function mapStateToProps(state) {
    return {
        language: state.auth.language,
        documents: state.info.documents,
        uploadFilesInfo: state.info.uploadFilesInfo,
        formValues:state.info
    }
}
export default connect(mapStateToProps, {addDocument,showPhoto,uploadID})(Document);